export default __webpack_public_path__ + "static/media/Maskgroup3.61e7af95.svg";